import React, { Fragment } from "react"

import Button from '@mui/material/Button'

const AppBarButton = ({
    title,
    href,
    icon
}) =>   <Fragment>
            <Button 
                color="inherit" 
                endIcon={icon} 
                href={href} 
                sx={{mr:2}}
            >
                {title}
            </Button>
        </Fragment>

export default AppBarButton